
const ConnectingDots = () => {
  return (
    <div>
        <svg width="8" height="94" viewBox="0 0 8 94" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="4" cy="4" r="4" fill="#8B959E"/>
<circle cx="4" cy="17" r="1" fill="#8B959E"/>
<circle cx="4" cy="27" r="1" fill="#8B959E"/>
<circle cx="4" cy="37" r="1" fill="#8B959E"/>
<circle cx="4" cy="47" r="1" fill="#8B959E"/>
<circle cx="4" cy="57" r="1" fill="#8B959E"/>
<circle cx="4" cy="67" r="1" fill="#8B959E"/>
<circle cx="4" cy="77" r="1" fill="#8B959E"/>
<circle cx="4" cy="90" r="4" fill="#0C0C0C"/>
</svg>

    </div>
  )
}

export default ConnectingDots